import useGetCustomerProfileRoles from './useGetCustomerProfileRoles'

export default useGetCustomerProfileRoles
